// Site footer. Matches the .site-footer / .footer-grid block in every
// design HTML (see 01-search.html line 2328).

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <a href="/" className="logo">
          <div className="logo-mark">K</div>
          <div className="logo-word">
            <span className="brand">the tarzan way</span>
            <span className="tag">by Kaira · est. 2018</span>
          </div>
        </a>
        <div className="links">
          <a href="/about">About</a>
          <a href="/help">Help</a>
          <a href="/terms">Terms</a>
          <a href="/privacy">Privacy</a>
        </div>
        <div className="copyright">© 2026 thetarzanway</div>
      </div>
    </footer>
  );
}
